<template>
  <bags-template
    :eye-bags="eyeBags"
    :eye-bags-type="eyeBagsType"
    :field-errors="fieldErrors"
    :is-eye-bags-type-visible="isEyeBagsTypeVisible"
    @field-change="onFieldChange"
  />
</template>

<script>
import BagsTemplate from '@/modules/questionnaire/components/steps/questionnaire/skin-appearance/bags/BagsTemplate';

import { makeStep, resetStoreValues } from '@/modules/questionnaire/mixins';
import { fieldBuilder } from '@/modules/questionnaire/mixins/makeStep';

import { yes, no } from '@/modules/questionnaire/api/helpers';

const { requiredField } = fieldBuilder;

const FIELDS = [requiredField('eyeBags'), requiredField('eyeBagsType')];

export default {
  name: 'Bags',
  components: {
    BagsTemplate
  },
  mixins: [makeStep(FIELDS), resetStoreValues],
  computed: {
    isEyeBagsTypeVisible() {
      return yes(this.eyeBags);
    }
  },
  watch: {
    eyeBags(newValue) {
      if (no(newValue)) {
        this.resetStoreFieldsByName(['eyeBagsType']);
        this.showNextStep();

        return;
      }

      this.scrollTo('#eye-bags-type');
    },
    eyeBagsType(newValue, oldValue) {
      if (!oldValue) {
        this.showNextStep();
      }
    }
  },
  methods: {
    isFieldVisible(fieldName) {
      if (fieldName === 'eyeBagsType') {
        return this.isEyeBagsTypeVisible;
      }

      return true;
    }
  }
};
</script>
